import SearchRepository from "./SearchRepository";
import DetailRepository from "./DetailRepository";
import DetailAccesslogRepository from "./DetailAccesslogRepository";
import GakumonRepository from "./GakumonRepository";
import TopRepository from "./TopRepository";

interface repositoryObject {
  [name: string]: any;
}

const repositories: repositoryObject = {
  search: SearchRepository,
  detail: DetailRepository,
  detailAccesslog: DetailAccesslogRepository,
  gakumon: GakumonRepository,
  top: TopRepository,
};

export const RepositoryFactory = {
  get: (name: string) => repositories[name],
  getQuery: (name: string) => repositories[name],
  post: (name: string) => repositories[name],
};
